import { ClassificationFilter, Status } from "@radarly/models/filters";

const isIncluded = (status: Status) => status === Status.Include;
const isExcluded = (status: Status) => status === Status.Exclude;
const isSelected = (status: Status) => isIncluded(status) || isExcluded(status);

export const getCheckValue = (status: Status, isNeutral: boolean) =>
  isNeutral || status === Status.None
    ? null
    : status === Status.Exclude
    ? false
    : true;

export function getOnChangeStatus(
  filter: ClassificationFilter,
  checked: boolean,
  isNeutral: boolean
) {
  if (checked && (!isIncluded(filter.status) || isNeutral)) {
    return Status.Include;
  }
  if (!checked && (!isExcluded(filter.status) || isNeutral)) {
    return Status.Exclude;
  }
  return Status.None;
}

export function getToggleClickStatus(status: Status) {
  if (isSelected(status)) return Status.None;
  return Status.Include;
}
